import { Box } from '@mui/material'
import { FC } from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface SeoStatusCellProps {
  params: GridRenderCellParams
  onClick?: (params: GridRenderCellParams) => void
}

const SeoStatusCell: FC<SeoStatusCellProps> = ({ params, onClick }) => {
  const { org_uuid: _org_uuid, isParent, PK: _PK, SK: _SK } = params?.row ?? {}
  const { organization } = params?.row ?? null
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        cursor: 'pointer',
        bgcolor: renderColorByString(
          isParent && organization?.seoStatus ? organization?.seoStatus ?? 'Not Started' : !isParent ? '–' : 'Staging'
        ),
      }}
      onClick={() => onClick(params)}
    >
      <Box
        sx={{
          bgcolor: renderColorByString(
            isParent && organization?.seoStatus ? organization?.seoStatus ?? 'Not Started' : !isParent ? '–' : 'Staging'
          ),
          textAlign: 'center',
          fontWeight: 'bold',
          width: '100%',
          height: '100%',
        }}
      >
        {isParent && organization?.seoStatus ? organization?.seoStatus ?? 'Not Started' : !isParent ? '–' : 'Staging'}
      </Box>
    </Box>
  )
}
export default SeoStatusCell
